/**
 * This function takes the desired type (=name of the class) and a piece of data and calls the constructor of
 * the type class with the data in a way that type checking continues to work.
 */
export class JsonUtilities {
    public static fromJson<T>(type: new (...args: unknown[]) => T, data: unknown, ...args: unknown[]): T {
        return new type(data, ...args);
    }
}
